import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/quickBetCardCricket.css';

import {ASSETS_URL} from '../../../constants/endpoints';
import {getGameFromChannel} from "../helpers/gameHelpers";
import {calculateTimeDifference, formatTimeInSecondsToS} from '../../../helpers/helperFunctions';
import {getText} from '../../../helpers/localization';
import cricketColorConfig from '../../../constants/configurations/cricketColorConfig.json';
import {NMB, PRE} from '../../../constants/identifiers';
import device from 'current-device';
import {addOpenBet, removeOpenBet} from '../actions/openBetsActions';
import eventLiveCounter from "./eventLiveCounter";

import {getMarketsByCode} from '../modules/cricket/helpers/marketHelpers';
import OddsButton from "../modules/cricket/components/oddsButton";
import {MATCH_WINNER} from "../modules/cricket/constants/marketTypes";


const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        openBetsList: state.vpp.openBetsList,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage
    };
};

class QuickBetCardCricket extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.isEventLive = false;
        this.isFirstTeamClicked = false;
        this.isDrawClicked = false;
        this.isLastTeamClicked = false;
        this.state = {
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            timeLeft: this._getTimeLeft(),
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
        };
    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000;
            if (Math.floor(timeLeft) === 0) {
                setTimeout(() => this.isEventLive = true, 200);
                setTimeout(() => this.isEventLive = false, 2000);
            }
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.state.games[this.state.selectedGameIndex].channel && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }
        return eventTime;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                events: storeData.vpp.events,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                openBetsList: storeData.vpp.openBetsList,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
            });
        }
    }

    render() {

        let selectedEvent = this.state.events[this.state.selectedEventIndex];

        let lastResultsUI;
        let topButtons;
        let middleButtons;
        let betTitle;
        let timeCounter;
        let backgroundImageUrl;
        if (this.state.events.length > 0 && this.state.events[this.state.selectedEventIndex] !== undefined) {
            if (device.mobile() && !device.tablet()) {
                if (window.screen.orientation && window.orientation !== undefined) {
                    if (window.orientation === -90 || window.orientation === 90) {
                        timeCounter = (
                            <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                    }
                } else if (window.orientation !== undefined) {
                    if (window.orientation === -90 || window.orientation === 90) {
                        timeCounter = (
                            <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                    }
                }
            }
            if (timeCounter === undefined) {
                let isEnabled = this._checkIfButtonsEnabled();
                betTitle = isEnabled ? (
                        <div className={style.betTitle}>{getText('SELECT_YOUR_BET_BELOW', this.props.store)}</div>)
                    : (<div className={style.betTitle}>{getText('NO_MORE_BETS', this.props.store)}</div>);
                topButtons = this._getTeamOutcomeUI(selectedEvent, isEnabled);
            }
            lastResultsUI = this._getLastResultsUI(this.state.games[this.state.selectedGameIndex]);

            backgroundImageUrl = `${ASSETS_URL}${getGameFromChannel(selectedEvent.channel, this.state.games).assetsPath}/backplate.png`;
        }

        return (
            <div className={style.mainContainer} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                {betTitle}
                {topButtons}
                {timeCounter}
                {lastResultsUI}
            </div>
        );
    }

    _checkIfButtonsEnabled() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        if (selectedEvent) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    if (selectedGame.controllerState === NMB || selectedGame.controllerState === PRE) {
                        return false;
                    }
                    break;
                }
            }
        }
        return true;
    }

    _getLastResultsUI(selectedGame) {
        if (selectedGame.lastResults === undefined || selectedGame.lastResults.length === 0) return <div
            className={style.prevContainer}></div>;

        let lastResults = selectedGame.lastResults;

        let results = [];
        lastResults.map((item) => results.push(item.result.split(';')[0]));

        let resultsListUI = results.splice(0, 8).map((result, index) => {
            let resultNumbers = result.split('-');
            let colorStyle;
            if (Number(resultNumbers[0]) <= 14.5) {
                colorStyle = style.ResultDown;
            } else {
                colorStyle = style.ResultUp;
            }

            return (<div key={index} className={style.eightResult}>
                    <div className={style.resultValue}>{result}</div>
                    <div className={style.resultColor}>
                        <div className={`${colorStyle} ${style.resultColorDiv}`}></div>
                    </div>
                </div>
            )
        });


        return (<div className={style.prevContainer}>
            <div className={style.prevGame}>
                <div className={style.previousText}>{getText('PREVIOUS', this.props.store)}</div>
                <div className={style.gamesText}>{getText('EIGHT_RESULTS', this.props.store)}</div>
            </div>
            <div id={'col2'} className={style.prevEightGame}>
                <div className={style.indexResult}>
                    <div className={style.over}>
                        <div className={style.indexUp}></div>
                        <div className={style.text}>{getText('OVER_145', this.props.store)}</div>
                    </div>
                    <div className={style.under}>
                        <div className={style.indexDown}></div>
                        <div className={style.text}>{getText('UNDER_145', this.props.store)}</div>
                    </div>
                </div>
                <div className={style.resultContainer}>
                    {resultsListUI}
                </div>
            </div>
        </div>)
    }

    _isChecked(openBetsList, market) {
        if (openBetsList.length > 0) {
            let currentSelectedGame = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex];
            let currentSelectedEvent = this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex];
            for (let i = 0; i < openBetsList.length; i++) {
                if (market && openBetsList[i].bets[0] && openBetsList[i].bets[0].market && openBetsList[i].bets[0].game && currentSelectedGame
                    && openBetsList[i].bets[0].game.channel === currentSelectedGame.channel
                    && openBetsList[i].bets[0].event && currentSelectedEvent
                    && openBetsList[i].bets[0].event.eventId === currentSelectedEvent.eventId
                    && openBetsList[i].bets[0].market.id === market.id) {
                    this.bet = openBetsList[i];
                    return true;
                }
            }
        }
        return false;
    }

    _placeBet(market, button) {
        let bet = {
            game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
            event: this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex],
            betType: MATCH_WINNER,
            market: market
        };

        this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsList));

        if (button === 1) {
            this.isFirstTeamClicked = true;
            setTimeout(() => this.isFirstTeamClicked = false, 1000);
        } else if (button === 2) {
            this.isDrawClicked = true;
            setTimeout(() => this.isDrawClicked = false, 1000);
        } else {
            this.isLastTeamClicked = true;
            setTimeout(() => this.isLastTeamClicked = false, 1000);
        }
    }

    _removeBet() {
        this.props.store.dispatch(removeOpenBet(this.bet));
    }

    _click(isEnabled, market, button) {

        if (!isEnabled) {
            return;
        }
        let isChecked = this._isChecked(this.state.openBetsList, market);
        !isChecked ? this._placeBet(market, button) : this._removeBet(market);
    }

    /*_findKit(kitId, length) {
        let id = '' + kitId;
        while (id.length < length) {
            id = '0' + id;
        }
        return id;
    }*/

    _getTeamOutcomeUI(selectedEvent, isEnabled) {
        let store = this.props.store;
        let storeData = store.getState();

        let marketList = selectedEvent.markets;
        let markets = getMarketsByCode(MATCH_WINNER, marketList);

        if (selectedEvent.awayTeamKit === undefined) return;

        let teamOneName = selectedEvent.teamOne.split(' ').join('');
        let teamTwoName = selectedEvent.teamTwo.split(' ').join('');

        let teamOneImageSrc;
        let teamTwoImageSrc;
        let teamOneFlagSrc;
        let teamTwoFlagSrc;
        let teamOneFlagIconStyle;
        let teamTwoFlagIconStyle;
        let cricketIconStyle;
        let cricketIconRightStyle;

        let firstTeam;
        let gameTitleBannerTeamOneColor;
        let gameTitleBannerTeamOneFontColor;
        let secondTeam;
        let gameTitleBannerTeamTwoColor;
        let gameTitleBannerTeamTwoFontColor;

        teamOneImageSrc = `${ASSETS_URL}cricket/silks/` + teamOneName + `.png`;
        teamTwoImageSrc = `${ASSETS_URL}cricket/silks/` + teamTwoName + `.png`;
        teamOneFlagSrc = `${ASSETS_URL}cricket/teamFlag/large/` + teamOneName + `.png`;
        teamTwoFlagSrc = `${ASSETS_URL}cricket/teamFlag/large/` + teamTwoName + `.png`;
        cricketIconStyle = style.cricketIcon;
        teamOneFlagIconStyle = style.teamOneFlagIconStyle;
        teamTwoFlagIconStyle = style.teamTwoFlagIconStyle;
        cricketIconRightStyle = style.cricketIconRight;

        firstTeam = cricketColorConfig.teams.filter((team) => team.team === teamOneName);
        gameTitleBannerTeamOneColor = firstTeam.length == 0
            ? cricketColorConfig.default.color.background
            : firstTeam[0].color.background;
        gameTitleBannerTeamOneFontColor = firstTeam.length == 0
            ? cricketColorConfig.default.color.font
            : firstTeam[0].color.font;

        secondTeam = cricketColorConfig.teams.filter((team) => team.team === teamTwoName);
        gameTitleBannerTeamTwoColor = secondTeam.length == 0
            ? cricketColorConfig.default.color.background
            : secondTeam[0].color.background;
        gameTitleBannerTeamTwoFontColor = secondTeam.length == 0
            ? cricketColorConfig.default.color.font
            : secondTeam[0].color.font;

        let teamOne = (
            <div className={style.teamImage}>
                <img
                    src={`${teamOneImageSrc}`}
                    className={`${cricketIconStyle}`}
                    alt={`icon_${teamOneName}`}/>
            </div>);

        let includeMarketLabel = this.props.market === undefined ? true : this.props.includeMarketLabel;

        const getMatchResultOddsValueStyle = (market) => this._isChecked(this.state.openBetsList, market)
            ? `${style.matchResultOddsValue} ${style.matchResultOddsValueChecked}`
            : style.matchResultOddsValue;


        let middlePortion = (
            <div className={style.teamNameImage}>
                <div className={style.middleContainer}>
                    <div className={style.gameTitleHeader}>

                        <div className={style.gameTitleBannerFirstTeam}
                             style={{
                                 color: gameTitleBannerTeamOneFontColor,
                                 backgroundColor: gameTitleBannerTeamOneColor
                             }}>
                            <div>
                                <img
                                    src={`${teamOneFlagSrc}`}
                                    className={`${style.flagIconStyle} ${teamOneFlagIconStyle}`}
                                    alt={`flag_${teamOneName}`}/>
                            </div>
                            {`${getText(selectedEvent.teamOne, this.props.store)}`}</div>
                        <div className={style.gameTitleBannerV}>{`${getText(`v`, this.props.store)}`}</div>
                    </div>
                    <div className={style.gameTitleBannerLastTeam}
                         style={{
                             color: gameTitleBannerTeamTwoFontColor,
                             backgroundColor: gameTitleBannerTeamTwoColor
                         }}>
                        {`${getText(selectedEvent.teamTwo, this.props.store)}`}
                        <div>
                            <img
                                src={`${teamTwoFlagSrc}`}
                                className={`${style.flagIconStyle} ${teamTwoFlagIconStyle}`}
                                alt={`flag_${teamOneName}`}/>
                        </div>
                    </div>
                </div>
                <div className={style.matchResultContainer}>
                    <div className={style.matchResultSubContainer}
                         onClick={() => this._click(isEnabled, markets[0], 1)}>
                        <div className={style.innerContainer}>
                            <div className={style.highlighterLeft}
                                 style={{backgroundColor: gameTitleBannerTeamOneColor}}></div>
                            <div className={style.matchResultTitleContainer}>
                                <div className={style.matchResultTitle}>{`${getText(teamOneName + `_short`, this.props.store)}`}</div>
                            </div>
                        </div>
                        <div className={getMatchResultOddsValueStyle(markets[0])}>
                            <OddsButton isClicked={this.isFirstTeamClicked} isQuickBet={true} active={false}
                                        store={store} market={markets[0]} includeMarketLabel={false}
                                        customStyle={style.oddsButtonCustomStyle} buttonStyle={style.buttonStyle}
                                        isEnabled={isEnabled} circleSize={'medium'}/>
                        </div>
                    </div>
                    <div className={style.matchResultSubContainer}
                         onClick={() => this._click(isEnabled, markets[2], 2)}>
                        <div className={style.innerContainer}>
                            <div className={style.highlighterMiddle}>
                            </div>
                            <div className={style.matchResultTitleContainer}>
                                <div className={style.matchResultTitle}>{`${getText(`DRAW_Cricket`, this.props.store)}`}
                                </div>
                            </div>
                        </div>
                        <div className={getMatchResultOddsValueStyle(markets[2])}>
                            <OddsButton isClicked={this.isDrawClicked} isQuickBet={true} active={false} store={store}
                                        market={markets[2]} includeMarketLabel={false}
                                        customStyle={style.oddsButtonCustomStyle} buttonStyle={style.buttonStyle}
                                        isEnabled={isEnabled} circleSize={'medium'}/>
                        </div>
                    </div>
                    <div className={style.matchResultSubContainer}
                         onClick={() => this._click(isEnabled, markets[1], 3)}>
                        <div className={style.innerContainer}>
                            <div className={style.highlighterRight}
                                 style={{backgroundColor: gameTitleBannerTeamTwoColor}}></div>
                            <div className={style.matchResultTitleContainer}>
                                <div className={style.matchResultTitle}>{`${getText(teamTwoName + `_short`, this.props.store)}`}
                                </div>
                            </div>
                        </div>
                        <div className={getMatchResultOddsValueStyle(markets[1])}>
                            <OddsButton isClicked={this.isLastTeamClicked} isQuickBet={true} active={false}
                                        store={store} market={markets[1]} includeMarketLabel={false}
                                        customStyle={style.oddsButtonCustomStyle} buttonStyle={style.buttonStyle}
                                        isEnabled={isEnabled} circleSize={'medium'}/>
                        </div>
                    </div>
                </div>
            </div>);

        let teamTwo = (
            <div className={style.teamImage}>
                <img
                    src={`${teamTwoImageSrc}`}
                    className={`${cricketIconRightStyle}`}
                    alt={`icon_${teamTwoName}`}/>
            </div>);

        return (
            <div className={style.simpleBetsContainer}>
                <div className={style.left}>
                    {teamOne}
                    <div className={style.drawContainer}>
                        {middlePortion}
                    </div>
                    {teamTwo}
                </div>
            </div>
        );

    }
}

export default connect(mapStateToProps)(QuickBetCardCricket);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/quickBetCardCricket.js